import React, { useState } from "react";
import { Button, DateField, Labeled, RecordContextProvider, TextField, useRefresh } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Grid } from "@mui/material";
import { MoneyField } from "server/components/Fields/MoneyField";
import UserField from "server/components/Fields/UserField";

const DetailsDialog = ({ year }) => {
  const refresh = useRefresh();
  const [details, setDetails] = useState(null);

  const fetchDetails = async () => {
    try {
      const { data } = await dataProvider.customRequest(specialistRequests.getHealthcareCourseDailyPrices(year));
      setDetails(data);
      refresh();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <ConfirmModal
      onOpen={fetchDetails}
      titleContent={"Детайли на дневна такса"}
      isConfirmButton={false}
      closeTitle="Затвори"
      dialogSize="md"
      triggerButton={
        <Button
          startIcon={<VisibilityIcon />}
          label="Детайли"
        />
      }
    >
      {details && (
        <RecordContextProvider value={details}>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              md={3}
            >
              <Labeled label="Година">
                <TextField source="year" />
              </Labeled>
            </Grid>

            <Grid
              item
              xs={12}
              md={3}
            >
              <Labeled label="Дневна такса (EUR)">
                <MoneyField source="price" />
              </Labeled>
            </Grid>

            <Grid
              item
              xs={12}
              md={3}
            >
              <Labeled label="Последно редактиран">
                <DateField
                  source="updatedOn"
                  locales="bg-BG"
                />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
            >
              <Labeled label="Последно редактиран">
                <UserField source="updatedByUserId" />
              </Labeled>
            </Grid>
          </Grid>
        </RecordContextProvider>
      )}
    </ConfirmModal>
  );
};

export default DetailsDialog;
